class TextLightbox extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector("[data-lightbox-trigger]");
    this.overlay = this.querySelector("[data-lightbox-overlay]");
    this.closeBtn = this.querySelector("[data-lightbox-close]");
    if (!this.trigger || !this.overlay) return;
    this.trigger.addEventListener("click", () => this.open());
    this.closeBtn?.addEventListener("click", () => this.close());
    this.overlay.addEventListener("click", (e) => {
      if (e.target === this.overlay) this.close();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.overlay.style.display !== "none") {
        this.close();
      }
    });
  }
  open() {
    this.overlay.style.display = "block";
    document.body.style.overflow = "hidden";
    requestAnimationFrame(() => {
      this.overlay.style.opacity = "1";
    });
  }
  close() {
    this.overlay.style.opacity = "0";
    this.overlay.addEventListener("transitionend", () => {
      this.overlay.style.display = "none";
      document.body.style.overflow = "";
    }, { once: true });
  }
}
customElements.define("text-lightbox", TextLightbox);
